export const RESOURCE_LIST_SKELETON_CLASS = 'bg-coco-accent';
